// i18n.ts — نفس الإعداد الحاليّ: http-backend يجلب public/locales/{lng}/translation.json.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { APP_VERSION } from '../version';

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'en',
		supportedLngs: ['ar', 'en', 'pt'],
		debug: false,
		interpolation: { escapeValue: false },
		// مفتاح مفقود من كل اللغات: فضِّل defaultValue الصريح المُمرَّر إلى t(key, fallback) إن
		// وُجد (نمط شائع عبر المشروع)، وإلّا أعِد سلسلة فارغة بدل اسم المفتاح الخام — يسمح لنمط
		// `t('key') || 'fallback'` (بلا defaultValue صريح) بالعمل بشكل صحيح بدل عرض المفتاح حرفيًّا.
		parseMissingKeyHandler: (_key: string, defaultValue?: string) => defaultValue ?? '',
		backend: {
			// كسر تخزين المتصفّح/الخادم الوسيط (CDN) المؤقّت لملفّات locales — عنوانها ثابت بين
			// الإصدارات (بخلاف حزم JS المُصدَّرة بأسماء تتضمّن hash)، فيبقى يُقدِّم نسخة قديمة إلى
			// الأبد حتى بعد نشر إصدار جديد يضيف مفاتيح جديدة. نفس الإصلاح في `frontend/src/i18n.js`.
			loadPath: `/locales/{{lng}}/{{ns}}.json?v=${APP_VERSION}`,
		},
	});

export default i18n;
